/*
 * @Author: van
 * @Date: 2021-08-10 17:38:51
 * @LastEditors: van
 * @LastEditTime: 2021-09-29 18:15:23
 */
import * as types from '../types';
import * as erpApi from '@/http/erpApi';

const state = {
    menu_id: '',
    menu_auth: [], // 菜单功能权限列表
    whiteList: [],
    blackList: [],
    menuBread:'',
    isMenuDrawer:false
};

const mutations = {
    [types.MENU_ID] (state, status) {
        state.menu_id = status;
    },
    [types.MENU_AUTH] (state, status) {
        state.menu_auth = status;
    },
    add_whiteList (state, name) {
        state.whiteList.push(name);
    },
    add_blackList (state, name) {
        state.blackList.push(name);
    },
    [types.MENUBREAD] (state, status) {
        state.menuBread = status;
    },
    [types.MENUBREAD] (state, status) {
        state.menuBread = status
    },
    [types.ISMENUDRAWER](state,status){
        state.isMenuDrawer = status
    }
};

const getters = {};

const actions = {
    // getMenuAuth ({ commit }) {
    //     erpApi
    //         .getMenuAuth(
    //             {
    //                 menu_id: state.menu_id
    //                     ? state.menu_id
    //                     : localStorage.getItem('menu_id')
    //             },
    //             'get'
    //         )
    //         .then(res => {
    //             if (res) {
    //                 commit(types.MENU_AUTH, res.data);
    //             }
    //         });
    // }
};
export default {
    state,
    actions,
    getters,
    mutations
};
